<template>
  <standard-layout :header="header">
    <template v-slot:main>
      <div class="my-2 p-2 bg-light">
        <slot name="up"/>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="list-group">
            <div class="list-group-item"
                 :class="{'active': item.id === selectedItemId}"
                 v-for="item in items" :key="item.id"
                 @click="$emit('select', item)">
              <slot :item="item" :selected="item.id === selectedItemId">
                {{ item.id }}
              </slot>
            </div>
          </div>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";

export default {
  props: {
    header: String,
    items: Array,
    selectedItemId: String
  },
  components: {StandardLayout}
}
</script>
